import { Alert, AlertTitle, Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import './CoincidenceList.css';
import Institution from '../../models/Institution';

interface CoincidenceListProps {
    coincidenceList: Institution[];
    setCoincidentValue?: (value: any | null) => void;
}

const CoincidenceList: React.FC<CoincidenceListProps> = ({ coincidenceList, setCoincidentValue }) => {
  const { t } = useTranslation();

  const toUpperCase = (itemName = ''): string => {
    return itemName.toUpperCase();
  };

  return (
    <Alert severity="warning" sx={{ marginTop: '20px' }}>
      <AlertTitle sx={{ marginBottom: '18px' }}> {t('messageCoincidenceList')}</AlertTitle>
      <Box className="EQXXI-CoincidenceList-Container">
        {coincidenceList.map((coincidenceItem, index) => {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent:'space-between'}} key={index}>
              <Typography variant="body2" gutterBottom key={coincidenceItem.name}>
                              - {toUpperCase(coincidenceItem.name)}
              </Typography>
              {setCoincidentValue && <Button sx={{padding:0}} onClick={()=>{
                setCoincidentValue(coincidenceItem)
              }}>Usar</Button>}
            </div>
          );
        })}
      </Box>
    </Alert>
  );
};

export default CoincidenceList;
